export function countTotalPages(total: number, rowsPerPage: number) {
  if (total === 0) return 0

  return Math.ceil(total / rowsPerPage) - 1
}
